import React, { createContext, useState, useContext } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [showModal, setShowModal] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [showModalInfoTransport, setShowModalInfoTransport] = useState(false);

    const handleShowModal = () => setShowModal(true);
    const handleHideModal = () => setShowModal(false);
    const handleShowModalInfo = () => setShowModalInfo(true);
    const handleHideModalInfo = () => setShowModalInfo(false);

    const handleShowModalInfoTransport = () => setShowModalInfoTransport(true);
    const handleHideModalInfoTransport = () => setShowModalInfoTransport(false);

    return (
        <ModalContext.Provider
            value={{
                showModal,
                handleShowModal,
                handleHideModal,
                showModalInfo,
                handleShowModalInfo,
                handleHideModalInfo,
                showModalInfoTransport,
                handleShowModalInfoTransport,
                handleHideModalInfoTransport
            }}
        >
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);
